import { render, staticRenderFns } from "./ModalAddAudition.vue?vue&type=template&id=65ab4c08&scoped=true&"
import script from "./ModalAddAudition.vue?vue&type=script&lang=js&"
export * from "./ModalAddAudition.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddAudition.vue?vue&type=style&index=0&id=65ab4c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ab4c08",
  null
  
)

export default component.exports